/**
 * Trims string fields in the CreateBankAccount mutation to prevent validation errors.
 * The API expects accountNumber and routing numbers to match patterns (digits only).
 * Leading/trailing whitespace from copy-paste or autofill causes InvalidInputError.
 * @see https://fundamental-portal.sentry.io/issues/BACKSTAGE-5Q
 */
const TRIM_FIELDS = [
  "accountNumber",
  "routingNumber",
  "alternativeRoutingNumber",
]

const trimBankAccountMutation = (parameters) => {
  const { mutation } = parameters

  if (!mutation) {
    return parameters
  }

  const trimmedMutation = { ...mutation }

  for (const field of TRIM_FIELDS) {
    if (typeof trimmedMutation[field] === "string") {
      trimmedMutation[field] = trimmedMutation[field].trim()
    }
  }

  return {
    ...parameters,
    mutation: trimmedMutation,
  }
}

export default trimBankAccountMutation
